// @generated by protoc-gen-es v1.10.0
// @generated from file ai/h2o/mlops/deployer/v1/pdb_spec.proto (package ai.h2o.deploy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * Represents configuration for Pod Disruption Budget (PDB).
 * Only one of min_available or max_unavailable should be specified.
 *
 * @generated from message ai.h2o.deploy.PodDisruptionBudgetSpec
 */
export const PodDisruptionBudgetSpec = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.deploy.PodDisruptionBudgetSpec",
  () => [
    { no: 1, name: "min_available", kind: "message", T: MinAvailable, oneof: "disruption_policy" },
    { no: 2, name: "max_unavailable", kind: "message", T: MaxUnavailable, oneof: "disruption_policy" },
  ],
);

/**
 * Represents minimum availability configuration
 *
 * @generated from message ai.h2o.deploy.MinAvailable
 */
export const MinAvailable = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.deploy.MinAvailable",
  () => [
    { no: 1, name: "pods", kind: "scalar", T: 5 /* ScalarType.INT32 */, oneof: "value" },
    { no: 2, name: "percentage", kind: "scalar", T: 5 /* ScalarType.INT32 */, oneof: "value" },
  ],
);

/**
 * Represents maximum unavailability configuration
 *
 * @generated from message ai.h2o.deploy.MaxUnavailable
 */
export const MaxUnavailable = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.deploy.MaxUnavailable",
  () => [
    { no: 1, name: "pods", kind: "scalar", T: 5 /* ScalarType.INT32 */, oneof: "value" },
    { no: 2, name: "percentage", kind: "scalar", T: 5 /* ScalarType.INT32 */, oneof: "value" },
  ],
);

